

















































import { Vue, Component } from 'vue-property-decorator'
import VueBase from '@/lib/vuebase'
import app from '@/lib/app'
import ajax from '@/lib/ajax'
import { Toast } from 'vant'
import PermissionDefinition from '@/lib/permission-definition'
// import NavBar from '@/components/nav-bar.vue'
@Component({
	components: {
		// NavBar
	}
})
export default class Index extends VueBase {
	title: string = '首页'
	active: any = 'home'
	userName: string = 'Admin'
	user: any = {}
	actionSheetShow: boolean = false
	searchForm: AccountPasswordDto = new AccountPasswordDto()
	errMsg: any = {
		oldPassword: '',
		newPassword: '',
		newPasswordTemp: ''
	}
	oldPassword: string = ''
	newPassword: string = ''
	newPasswordTemp: string = ''
	images: Array<string> = [
		'/imgs/banner01.png',
		'/imgs/banner02.png'
	]
	menuList: Array<any> = [
		{
			id: 'dispatched',
			name: '待派工',
			icon: 'upgrade',
			color: '#00CDCD',
			path: '/dispatchManager',
		},
		{
			id: 'statementing',
			name: '待结单',
			icon: 'clock-o',
			color: '#FF4500',
			path: '/statementManager',
			// badgeCount: 0
		},
		{
			id: 'statemented',
			name: '已结单',
			icon: 'passed',
			color: '#00FF7F',
			path: '/statementedManager',
		},
		{
			id: 'returnVisited',
			name: '已回访',
			icon: 'share',
			color: '#00CDCD',
			path: '/returnVisitedManager',
		},
		// {
		// 	id: 'blackList',
		// 	name: '黑名单',
		// 	icon: 'notes-o',
		// 	color: '#000000',
		// 	path: '/blackListManager',
		// },
		{
			id: 'partsRecord',
			name: '产品消耗',
			icon: 'exchange',
			color: '#FF3030',
			path: '/partsRecordManager',
		},
		{
			id: 'school',
			name: '驾校查询',
			icon: 'shop-o',
			color: '#FF3030',
			path: '/schoolManager',
		},
		{
			id: 'teacher',
			name: '教练查询',
			icon: 'manager-o',
			color: '#FF3030',
			path: '/TeacherManager',
		},
		{
			id: 'carList',
			name: '车辆查询',
			icon: 'manager-o',
			color: '#FF3030',
			path: '/CarListManager',
		},
		{
			id: 'studentPhoto',
			name: '学员照片',
			icon: 'manager-o',
			color: '#FF3030',
			path: '/studentPhotoManager',
		},
	]
	oldPasswordBlur() {
		if (this.oldPassword.length !== 6) {
			this.errMsg.oldPassword = '旧密码长度不正确'
			return false
		} else {
			this.errMsg.oldPassword = ''
			return true
		}
	}
	newPasswordBlur() {
		let reg = new RegExp(/[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/)
		if (this.newPassword.length !== 6 || this.newPassword === '') {
			this.errMsg.newPassword = '新密码长度不正确'
			return false
		} else if (reg.test(this.newPassword)) {
			this.errMsg.newPassword = ''
			return true
		} else {
			this.errMsg.newPassword = '新密码格式不正确'
			return false
		}
	}
	newPasswordTempBlur() {
		if (this.newPassword === this.newPasswordTemp) {
			this.errMsg.newPasswordTemp = ''
			return true
		} else {
			this.errMsg.newPasswordTemp = '两次密码输入不一致！'
			return false
		}
	}
	gridClick(item: any) {
		this.$router.push(item.path)
	}
	async getUserName() {
		this.user = await this.getCurrentUser()
		this.userName = `${this.user.userName}`
	}
	// 退出登录并解绑微信openid
	logout() {
		this.$dialog.confirm({
			message: '确定退出登录吗？',
		}).then(async () => {
			if (this.user.userId !== undefined) {
				await ajax.post(`/api/auth/unbind-account-openid/` + this.user.userId).then(rep => {
					app.auth.logout()
					// this.$store.dispatch('permission/clearUserPermissionKeys')
					// this.$store.dispatch('app/clearCurrentUser')
					this.$router.push('/auth')
				}).finally(() => { })
			} else {
				this.$router.push('/auth')
			}
			app.auth.logout()
			this.$router.push('/auth')
		}).catch((err) => { })
	}
	async created() {
		this.getUserName()

		if (this.$route.query.type !== undefined)
			this.active = this.$route.query.type
	}
	async mounted() {
		// await this.$store.dispatch('permission/getCurrentUserPermissionKeys')
	}
	actionSheetChange() {
		this.actionSheetShow = true
	}
	// 提交
	async onSubmit() {
		this.searchForm.id = this.user.accountId
		this.searchForm.oldPassword = this.oldPassword
		this.searchForm.newPassword = this.newPassword
		await ajax.put('/api/app/account/oldPassword', this.searchForm).then(rep => {
			Toast.success('修改成功')
		}).finally(() => { })
	}
}
class AccountPasswordDto {
	/// <summary>
	///
	/// </summary>
	id: string | null = null
	/// <summary>
	/// 旧密码
	/// </summary>
	oldPassword: string | null = null
	/// <summary>
	/// 新密码
	/// </summary>
	newPassword: string | null = null
}
